import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { brandConfig } from 'constants/saudi-rewards.constants';

import {
  GradientImage,
  NoiseImage,
} from 'components/@loyalty/Card/Card.styles';
import PortraitCardContainer from 'components/@loyalty/PortraitCardContainer';

interface Props {
  children?: ReactNode;
}

const SaudiRewardsCardPortrait = ({ children }: Props) => {
  return (
    <PortraitCardContainer
      backgroundColor={brandConfig.backgroundColor}
      borderColor={brandConfig.borderColor}
      mixBlendMode={brandConfig.mixBlendMode}
    >
      <GradientImage variant="portrait" />
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundColor: brandConfig.subLayer,
          mixBlendMode: 'soft-light',
          // Design says 0.3, but figma gives a different constract with blend modes, hence we use 0.5 in code.
          opacity: 0.5,
        }}
      />
      <NoiseImage variant="portrait" />
      {children}
    </PortraitCardContainer>
  );
};

export default SaudiRewardsCardPortrait;
